import React from 'react';

interface ProgressIndicatorProps {
  currentStep: number;
  totalSteps: number;
}

export const ProgressIndicator = ({ 
  currentStep, 
  totalSteps 
}: ProgressIndicatorProps) => {
  const progressPercentage = ((currentStep - 1) / (totalSteps - 1)) * 100;
  
  return (
    <div className="progress-container">
      <div className="progress-bar">
        <div 
          className="progress-fill" 
          style={{ width: `${progressPercentage}%` }}
        />
      </div>
      <div className="progress-text" style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0.5rem', fontSize: '0.875rem', color: '#686C6F' }}>
        <span>Section {currentStep} of {totalSteps}</span>
        <span>{Math.round(progressPercentage)}%</span>
      </div>
    </div>
  );
};